module.exports = __webpack_public_path__ + "img/LTS_MZ_13.2b238be6.gif";